// Namespaced so it never collides with other Redo apps' tokens, and so
// clearing it removes only this app's session.
const AUTH_TOKEN_KEY = "redo.partners-portal.auth_token";

// Anything that isn't three base64url segments is treated as no token,
// rather than sent as a bearer token that's sure to 401.
const JWT_PATTERN = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

export function readAuthToken(): string | undefined {
  let raw: string | null;
  try {
    raw = localStorage.getItem(AUTH_TOKEN_KEY);
  } catch {
    return undefined;
  }
  return raw && JWT_PATTERN.test(raw) ? raw : undefined;
}

export function writeAuthToken(token: string): void {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function clearAuthToken(): void {
  localStorage.removeItem(AUTH_TOKEN_KEY);
}

/** Calls back when another tab signs in or out. */
export function subscribeAuthTokenChanges(
  handler: (token: string | undefined) => void,
): () => void {
  const onStorage = (event: StorageEvent) => {
    if (event.key === AUTH_TOKEN_KEY && event.storageArea === localStorage) {
      handler(readAuthToken());
    }
  };
  window.addEventListener("storage", onStorage);
  return () => window.removeEventListener("storage", onStorage);
}
